export const allCountryCodes = ['ar', 'be', 'br', 'ca', 'co', 'de', 'dk', 'fi', 'it', 'my', 'mx', 'nl', 'no', 'es'] as const;
export type CountryCode = (typeof allCountryCodes)[number];
export const isCountryCode = (value?: string): value is CountryCode => {
    return !!value && allCountryCodes.some(item => item === value.toLowerCase());
};
